/* eslint-disable */
import React from 'react'
import Loader from '../loaders/loader'
import {Link} from 'react-router-dom'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import AutoComplete from '../BaseComponent/autocomplete'
import $ from 'jquery'
import {message, Icon} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import Sort from '../Pagination/Sort'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import moment from 'moment'

export default class SortedProductsReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      providerId: '',
      selectedOperator: null,
      operators: [],
      dateMin: null,
      dateMax: null,
      items: [],
      totalCount: 0,
      columns: [
        {
          name: 'ردیف',
          value: 'row',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد محصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بارکد محصول',
          value: 'code',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'sellerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'اپراتور',
          value: 'user',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ',
          value: 'date',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'مقدار',
          value: 'qty',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'واحد',
          value: 'unitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وزن (کیلوگرم)',
          value: 'weight',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'delete',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      // delete properties
      modalDelete: false,
      deleteId: null
    }
  }

  getOperators = () => {
    return http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })
  }

  getOperatorValue = (value) => {
    if (value === null) {
      this.setState({
        selectedOperator: ''
      })
    } else {
      this.setState({
        selectedOperator: value
      })
    }
  }

  filter() {
    sessionStorage.setItem('pageNumber', 1)
    sessionStorage.setItem('dropDownVal', 10)

    const {providerId, selectedOperator, dateMin, dateMax} = this.state
    const id = $('#filterId')
      .val()
      .trim()
    const articleId = $('#articleId')
      .val()
      .trim()

    if (
      id === '' &&
      providerId === '' &&
      articleId === '' &&
      (selectedOperator === null || selectedOperator === '') &&
      !dateMin &&
      !dateMax
    ) {
      message.error('یک فیلتر وارد شود')
      return
    }

    let filterStr = `id=${id}&sellerId=${providerId}&articleId=${articleId}&userId=${
      selectedOperator && selectedOperator !== '' ? selectedOperator.personId : ''
    }`

    if (dateMin) {
      filterStr += `&dateMin=${this.epochFrom(dateMin)}`
    }

    if (dateMax) {
      filterStr += `&dateMax=${this.epochFrom(dateMax)}`
    }

    this.setState({
      loading: true
    })

    sessionStorage.setItem('params', filterStr)

    http
      .get(`public/cartStationArrangement/report?pageSize=10&pageNumber=1&${filterStr}`)
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            items: response.data.object.result.map((item) => {
              return {
                ...item,
                weight: item.weight ? item.weight / 1000 : null
              }
            }),
            totalCount: response.data.object.countAll
          })
        } else {
          this.setState({
            items: [],
            totalCount: 0
          })
        }
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  onResultFetched(data) {
    this.setState({
      items: data.map((item) => {
        return {
          ...item,
          weight: item.weight ? item.weight / 1000 : null
        }
      })
    })
  }

  changeDropDown(data) {
    this.setState({
      items: data,
      totalCount: sessionStorage.getItem('countAll')
    })
  }

  exportPrint = async () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    window.print()
  }

  exportExcel = () => {
    http
      .get(
        `public/cartStationArrangement/report?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result.map((item) => {
              return {
                ...item,
                date: item.date ? jMoment(item.date).format('jYYYY/jD/jM') : '-',
                weight: item.weight ? item.weight / 1000 : null
              }
            })
          })

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  showDeleteModal = (id) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      deleteId: id
    })
  }

  deleteItem = () => {
    const id = this.state.deleteId
    http
      .delete(`public/cartStationArrangement/${id}/delete`, {})
      .then((response) => {
        if (response.data.error === null) {
          message.success('کالای چیده شده با موفقیت حذف شد')
          this.filter()
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch(() => {})
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateMinChange = (date) => {
    this.setState({
      dateMin: date
    })
  }

  handleDateMaxChange = (date) => {
    this.setState({
      dateMax: date
    })
  }

  componentDidMount() {
    this.getOperators()

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  render() {
    const {loading, columns} = this.state
    const urlParams = sessionStorage.getItem('params')
    const excelColumns = columns.map((item) => {
      return {
        title: item.name,
        value: item.value
      }
    })
    const pageNumber = sessionStorage.getItem('pageNumber')
    const dropDownVal = sessionStorage.getItem('dropDownVal')

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <thead>
              <tr>
                <td colSpan="100%" className="rightHeader">
                  <div className="d-flex align-items-center justify-content-between">
                    <div style={{fontWeight: '600'}}>
                      {'تاریخ گزارش گیری : ' + jMoment().format('jYYYY/jM/jD HH:mm')}
                    </div>
                    <h3 style={{fontWeight: '900'}}>{'گزارش کالاهای چیده شده'}</h3>
                    <div style={{fontWeight: '600'}}>{'گزارش گیرنده : ' + cookie.load('name')}</div>
                  </div>
                </td>
              </tr>
              <tr id="firstRowPrint">
                {columns
                  .filter((col) => col.value !== 'delete')
                  .map((col, index) => (
                    <td className="borderHeader">{col.name}</td>
                  ))}
              </tr>
            </thead>

            <tbody>
              {this.state.items.map((item, index) => (
                <tr key={index}>
                  <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                  <td>{item.id}</td>
                  <td>{item.articleId}</td>
                  <td>{item.title}</td>
                  <td>{item.code}</td>
                  {/* TODO: sellertId should replace with sellerName */}
                  <td>{item.sellerId}</td>
                  <td>{item.user.name}</td>
                  <td>{item.date ? jMoment(item.date).format('jYYYY/jM/jD') : '-'}</td>
                  <td>{item.quantity}</td>
                  <td>{item.unitTitle}</td>
                  <td>{item.weight}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش کالاهای چیده شده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'id'}
                field={'id'}
                title={'شناسه'}
                width="50px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'articleId'}
                field={'articleId'}
                title={'کد محصول'}
                width="50px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'title'}
                field={'title'}
                title={'نام محصول'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'code'}
                field={'code'}
                title={'بارکد محصول'}
                width="50px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sellerName'}
                field={'sellerName'}
                title={'تامین کننده'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'user.name'}
                field={'user.name'}
                title={'اپراتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'date'}
                field={'date'}
                title={'تاریخ'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'quantity'}
                field={'quantity'}
                title={'مقدار'}
                width="50px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'unitTitle'}
                field={'unitTitle'}
                title={'واحد'}
                width="70px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'weight'}
                field={'weight'}
                title={'وزن (کیلوگرم)'}
                width="70px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش کالاهای چیده شده</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={'public/cartStationArrangement/report'}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="test"
                  execelUrl={'public/cartStationArrangement/report?export=true'}
                  excelColumns={excelColumns}
                  printComponent={this.printTable}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} disabled={!this.state.items.length} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" disabled={!this.state.items.length} onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>شناسه</label>
                  <input className="form-control" id="filterId" type="text" />
                </div>

                <div className="formComponent">
                  <label>کد محصول</label>
                  <input className="form-control" id="articleId" type="text" />
                </div>

                <div className="formComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getOperatorValue}
                    lableText="اپراتور"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold">تاریخ از :</label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      inline
                      okLabel="تأیید"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      cancelLabel="لغو"
                      labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                      value={this.state.dateMin}
                      id="date"
                      onChange={this.handleDateMinChange}
                      TextFieldComponent={this.date}
                      readOnly
                      clearable
                      clearLabel="حذف"
                    />
                  </MuiPickersUtilsProvider>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold">تاریخ تا :</label>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      inline
                      okLabel="تأیید"
                      autoOk={true}
                      leftArrowIcon={<Icon type="left" />}
                      rightArrowIcon={<Icon type="right" />}
                      cancelLabel="لغو"
                      labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                      value={this.state.dateMax}
                      id="date"
                      onChange={this.handleDateMaxChange}
                      TextFieldComponent={this.date}
                      readOnly
                      clearable
                      clearLabel="حذف"
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>

              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            {this.state.items.length > 0 ? (
              <div className="showBaseTable">
                <table className="baseTable">
                  <Sort data={this.state.columns} getSort={this.getSort} />
                  <tbody>
                    {this.state.items.map((item, index) => (
                      <tr key={index}>
                        <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                        <td>{item.id}</td>
                        <td>{item.articleId}</td>
                        <td>{item.title}</td>
                        <td>{item.code}</td>
                        {/* TODO: sellertId should replace with sellerName*/}
                        <td>{item.sellerId}</td>
                        <td>{item.user.name}</td>
                        <td>{item.date ? jMoment(item.date).format('jYYYY/jM/jD') : '-'}</td>
                        <td>{item.quantity}</td>
                        <td>{item.unitTitle}</td>
                        <td>{item.weight}</td>
                        <td>
                          <button onClick={() => this.showDeleteModal(item.id)}>
                            <img src={require('../../image/trash.svg')} alt="" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="paginationWrapp">
                  <Page
                    defaultCurrent={1}
                    total={this.state.totalCount}
                    onResultFetched={this.onResultFetched.bind(this)}
                    url={'public/cartStationArrangement/report'}
                    urlParams={urlParams}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>

        <Modal isOpen={this.state.modalDelete} toggle={() => this.setState({modalDelete: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalDelete: false})}>حذف کالای چیده شده</ModalHeader>
          <ModalBody>
            <h5 className="font-weight-bold text-center">آیا از حذف کالای چیده شده اطمینان دارید؟</h5>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteItem}>
              حذف کالای چیده شده
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalDelete: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
